import { Fragment, MouseEventHandler } from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
type step = {
  title?: string;
  id: number | string;
  onClick?: MouseEventHandler<HTMLDivElement> | undefined;
} | null;

export default function StepperService({
  steps,
  active,
  clickable = false,
  showDone = false,
}: {
  steps?: step[];
  active?: number | string;
  clickable?: boolean;
  showDone?: boolean;
}) {
  const list = steps?.filter((x) => x);
  return (
    <div className={styles.stepper}>
      {list?.map((step: step, index: number) => (
        <Fragment key={index}>
          {step && (
            <div
              className={`${styles.stepWrapper} ${clickable && 'cursor-pointer'} ${index === list?.length - 1 ? styles.lastStep : ''}`}
              onClick={(e) => {
                clickable && step?.onClick ? step?.onClick(e) : () => {};
              }}
            >
              <div className={styles.step}>
                <span
                  className={`${styles.circle} ${active == step?.id || (showDone && active && active > step?.id) ? styles.active : ''}`}
                >
                  {showDone && active && active > step?.id ? (
                    <MainIcons.CheckedIcon width="15px" height="15px" fill="var(--paper)" />
                  ) : (
                    index + 1
                  )}
                </span>

                <span className={`${styles.label} ${active == step?.id ? styles.activeLabel : ''}`}>
                  {step?.title}
                </span>

                {index !== list?.length - 1 && <div className={styles.line} />}
              </div>
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
}
